import { TextRegular } from 'UiKit/typography';

import ActionButton from 'View/report-attendance-operator/component/action-button';

import styles from './styles.module.css';

export const getTableList = [
  {
    name: 'Tanggal',
    width: 150,
    key: 'date',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Shift',
    width: 150,
    key: 'shiftName',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Clock-in',
    width: 150,
    key: 'clockInTime',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Clock-out',
    width: 150,
    key: 'clockOutTime',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Pelanggaran Istirahat',
    width: 200,
    key: 'totalBreakViolations',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Pelanggaran Absen Kamera',
    width: 200,
    key: 'totalCameraViolations',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Status Kehadiran',
    width: 160,
    key: 'clockInOutViolation',
    component: ({ value }) => {
      const isViolated = value?.isViolated;
      return (
        <TextRegular
          className={`${styles['column__text']} ${styles['column__text--truncate']} ${
            !isViolated ? styles['column__text--success'] : styles['column__text--error']
          }`}
        >
          {value?.reason || '-'}
        </TextRegular>
      );
    },
  },
  {
    name: 'Action',
    width: 150,
    position: 'center',
    rightSticky: 0,
    component: ({ values }) => <ActionButton values={values} />,
  },
];
